/* istanbul ignore next */
function safeWindowListenerAdd(eventName, callback) {
    if (typeof window !== 'undefined') {
        window.addEventListener(eventName, callback);
    }
}

/* istanbul ignore next */
function safeWindowListenerRemove(eventName, callback) {
    if (typeof window !== 'undefined') {
        window.removeEventListener(eventName, callback);
    }
}

export {safeWindowListenerAdd, safeWindowListenerRemove};
